// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1rE9D-rs8u1yEd {\n  color: #172B4D;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.008em;\n  line-height: 24px;\n  margin-top: 28px;\n  display: block;\n  text-align: center;\n  margin-top: 64px;\n  margin-bottom: 16px;\n}\n._2LyKtCw-Mmimd_ {\n  color: #172B4D;\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  line-height: 20px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMessage": "_1rE9D-rs8u1yEd",
	"secondaryMessage": "_2LyKtCw-Mmimd_"
};
export default ___CSS_LOADER_EXPORT___;
